import React, { useEffect } from 'react';
import './PartnerModal.css';

const PARTNERS = {
  starex: {
    name: 'Starex University',
    hero: {
      image: '/heroes/starx.webp',
      alt: 'Starex University',
      title: 'Starex University',
      location: 'Gurugram, Haryana',
      tags: ['Private', 'UGC Approved', 'Est. 2016'],
    },
    highlightsTitle: 'University Highlights',
    highlights: [
      { label: 'Established | Type', value: '2016 | Private' },
      { label: 'Location', value: 'NH-48, Vill- Binola, P.O. Bhorakalan, Gurugram, Haryana 122413' },
      { label: 'Approved by', value: 'UGC' },
      { label: 'Affiliations', value: 'Pharmacy Council of India (PCI), Bar Council of India (BCI)' },
      { label: 'Set by', value: 'Haryana Government' },
      { label: 'Courses Offered', value: 'UG, PG, PhD & Integrated programs' },
      { label: 'Application Mode', value: 'Online' },
      { label: 'Admission Criterion', value: 'Test-Based followed by an Interview' },
      { label: 'Median Package', value: 'INR 2,50,000 (UG)' },
      { label: 'Official Website', value: 'https://www.starexuniversity.com/', isLink: true },
    ],
    about: [
      'Private institution Act of 2006 allowed Starex University to be founded as a private institution in 2016. Situated in Gurugram, Haryana, the institution holds recognition from the UGC and is associated with both the Pharmacy Council of India and the Bar Council of India. There are collaborations between the Ministry of MSME and Starex University, which has 16 departments offering a variety of academic specialisations.',
      'Starex provides UG, PG, Doctorate, and Integrated programmes in Pharmaceutical Science, Law, Engineering, Fashion Design, CS, Commerce, Humanities, and more. Admission is primarily test-based followed by an interview. JEE-Main scores are also accepted for B.Tech admission.',
      'Located on a 35-acre green campus along the Delhi-Jaipur Highway (NH-48), it is known for its well-maintained grounds, perfect lawns, and stunning surroundings.',
    ],
    courses: [
      // Agriculture
      { program: 'Agriculture', course: 'B.Sc Agriculture', duration: '4 Years', eligibility: '10+2 with PCB/Agri (45%)' },
      { program: '', course: 'M.Sc Entomology', duration: '2 Years', eligibility: 'B.Sc Agri (50%)' },
      { program: '', course: 'M.Sc Soil Science', duration: '2 Years', eligibility: 'B.Sc Agri (50%)' },
      // Commerce & Management
      { program: 'Commerce & Management', course: 'B.Com / B.Com (Hons.)', duration: '3+1 Years', eligibility: '10+2 (45%)' },
      { program: '', course: 'BBA', duration: '3+1 Years', eligibility: '10+2 (45%)' },
      { program: '', course: 'M.Com', duration: '2 Years', eligibility: 'B.Com/BBA/BA (45%)' },
      { program: '', course: 'MBA', duration: '2 Years', eligibility: 'Graduation (45%)' },
      // Computer Science
      { program: 'Computer Science', course: 'BCA', duration: '3 Years', eligibility: '10+2 (45%)' },
      { program: '', course: 'BCA (AI)', duration: '3 Years', eligibility: '10+2 (45%)', badge: 'Minor Degree with IIT Mandi' },
      { program: '', course: 'MCA', duration: '2 Years', eligibility: 'BCA/BSc IT/B.Tech (45%)' },
      // Engineering & Technology
      { program: 'Engineering & Technology', course: 'B.Tech CSE', duration: '4 Years', eligibility: '10+2 PCM (45%)' },
      { program: '', course: 'B.Tech CSE (AI)', duration: '4 Years', eligibility: '10+2 PCM (45%)', badge: 'Minor Degree with IIT Mandi' },
      // Hotel Management
      { program: 'Hotel Management', course: 'BHM', duration: '3+1 Years', eligibility: '10+2 (45%)' },
      { program: '', course: 'MHMCT', duration: '2 Years', eligibility: 'Graduation (45%)' },
      // Humanities
      { program: 'Humanities', course: 'BA', duration: '3 Years', eligibility: '10+2 (45%)' },
      { program: '', course: 'MA (English/Pol Sci/Psychology)', duration: '2 Years', eligibility: 'Graduation (45%)' },
      // Law
      { program: 'Law', course: 'BA LLB (Hons.)', duration: '5 Years', eligibility: '10+2 (45%) + Age Criteria' },
      { program: '', course: 'BBA LLB (Hons.)', duration: '5 Years', eligibility: '10+2 (45%) + Age Criteria' },
      { program: '', course: 'LLB', duration: '3 Years', eligibility: 'Graduation (45%)' },
      { program: '', course: 'LLM', duration: '2 Years', eligibility: 'LLB (50%)' },
      // Life Sciences
      { program: 'Life Sciences', course: 'B.Sc Forensic Science', duration: '3 Years', eligibility: '10+2 (45%)' },
      { program: '', course: 'B.Sc Medical', duration: '4 Years', eligibility: '10+2 PCB (45%)' },
      { program: '', course: 'B.Sc. Biotechnology', duration: '3 Years', eligibility: '10+2 PCB (50%)' },
      { program: '', course: 'M.Sc (Botany/Zoology/Microbiology)', duration: '2 Years', eligibility: 'Relevant Graduation (45%)' },
      // Pharmaceutical Sciences
      { program: 'Pharmaceutical Sciences', course: 'B.Pharmacy', duration: '4 Years', eligibility: '10+2 with PCB/PCM (45%)' },
      { program: '', course: 'Diploma in Pharmacy', duration: '2 Years', eligibility: '10+2 with Physics & Chemistry + Biology/Math (45%)' },
      { program: '', course: 'M.Pharm Pharmaceutics/Pharma Chemistry', duration: '2 Years', eligibility: 'B.Pharm with 45%' },
      // Physical Sciences
      { program: 'Physical Sciences', course: 'B.Sc Non-Medical', duration: '4 Years', eligibility: '10+2 PCM (45%)' },
      { program: '', course: 'M.Sc Physics/Chemistry/Math', duration: '2 Years', eligibility: 'Relevant Graduation (45%)' },
    ],
    placements: [
      <>Starex University offers wide placement opportunities with nearly 100% placement. The average annual package is approximately <strong>INR 3,00,000</strong>. The university has also tied up with NASSCOM to train students for IT-related jobs.</>,
      <>According to the NIRF Report 2024, the Median Package offered to a UG Graduate stands at <strong>INR 2,50,000</strong>.</>,
    ],
    extraSections: [
      {
        title: 'Scholarships',
        paragraphs: ['Scholarships are available for students from economically weaker sections and for meritorious students. The university also facilitates Haryana Government scholarships, fee installment options, and education loans.'],
      },
    ],
    facilities: [
      { title: 'Library', desc: 'Mahatma Budh Central Library with DELNET, West Law repositories, Wi-Fi, scanning, Xerox, and separate reading rooms.' },
      { title: 'Hostel', desc: 'Separate hostels for boys and girls with Wi-Fi, 24×7 electricity & water, mess hall, AC/non-AC rooms, and biometric security gates.' },
      { title: 'Wi-Fi', desc: 'Internet access across hostels, campus premises, and library.' },
      { title: 'Transportation', desc: 'Bus facilities covering Gurugram and Delhi, including rural and urban areas.' },
      { title: 'Cafeteria', desc: 'Starex Café providing nutritious meals at affordable rates.' },
      { title: 'Gym', desc: 'Well-equipped gym open for day scholars and hostlers with experienced fitness professionals.' },
    ],
  },

  iitmandi: {
    name: 'IIT Mandi',
    hero: {
      image: '/heroes/iitmandi.webp',
      alt: 'IIT Mandi',
      title: 'Indian Institute of Technology Mandi',
      location: 'Kamand, Himachal Pradesh',
      tags: ['Public', 'Institute of National Importance', 'Est. 2009'],
    },
    highlightsTitle: 'Institute Highlights',
    highlights: [
      { label: 'Established | Type', value: '2009 | Public (Institute of National Importance)' },
      { label: 'Location', value: 'Kamand, Mandi District, Himachal Pradesh 175005' },
      { label: 'Approved by', value: 'Ministry of Education (GoI) | UGC | AICTE' },
      { label: 'Recognized as', value: 'Institute of National Importance' },
      { label: 'NIRF Ranking', value: '#26 in Engineering (2025) | #9 in Innovation' },
      { label: 'Campus Size', value: '538 Acres — Kamand Valley, HP' },
      { label: 'Courses Offered', value: 'B.Tech, M.Tech, M.Sc, MBA, MS & PhD programs' },
      { label: 'Application Mode', value: 'Online (JEE Advanced for B.Tech)' },
      { label: 'Highest Package', value: 'INR 52 LPA (2024–25)' },
      { label: 'Average Package', value: 'INR 22.38 LPA — B.Tech (2024–25)' },
      { label: 'Official Website', value: 'https://www.iitmandi.ac.in', isLink: true },
    ],
    about: [
      'Indian Institute of Technology Mandi is a premier public technical university established in 2009, located in the scenic Kamand Valley of Himachal Pradesh on the banks of the Uhl River. As one of India\'s Institutes of National Importance, IIT Mandi operates through nine schools and nine research centres spanning engineering, sciences, humanities, management, and design.',
      'The institute has rapidly grown into a research powerhouse, achieving #26 in NIRF Engineering Rankings 2025 and #9 in Innovation. IIT Mandi has strong ties with national and international universities, industries, and research organisations, making it a leading hub of technological innovation in the Himalayan region.',
      'CampusXL students enrolled in BCA (AI) and B.Tech CSE (AI) programs receive a Minor Degree from IIT Mandi, giving them direct access to IIT Mandi\'s academic curriculum, faculty expertise, and brand recognition.',
    ],
    courses: [
      { program: 'Computer Science', course: 'BCA (AI)', duration: '3 Years', eligibility: '10+2 (45%)', badge: 'Minor Degree with IIT Mandi' },
      { program: '', course: 'B.Tech CSE (AI)', duration: '4 Years', eligibility: '10+2 PCM (45%)', badge: 'Minor Degree with IIT Mandi' },
    ],
    placements: [
      <>IIT Mandi's placement record for the 2024–25 batch is exceptional. The <strong>highest package stood at INR 52 LPA</strong> (Zomato — CSE/DSE/EE/ME branches). The average package for CSE graduates was <strong>INR 26.55 LPA</strong>, while the overall B.Tech average was <strong>INR 22.38 LPA</strong> with a median of INR 18.5 LPA.</>,
      <>Over <strong>192 companies</strong> recruited from campus including Microsoft, Amazon, Zomato, Flipkart, Infosys, TCS, IBM, HCL, and ICICI Bank. 72.39% of the B.Tech batch secured placements through campus drives.</>,
    ],
    extraSections: [
      {
        title: 'Minor Degree Advantage',
        paragraphs: ['Students pursuing BCA (AI) or B.Tech CSE (AI) through CampusXL get an official Minor Degree credential from IIT Mandi — one of India\'s most prestigious technical institutes. This adds significant value to your resume and opens doors to opportunities typically available only to IIT alumni.'],
      },
    ],
    facilities: [
      { title: 'Library', desc: 'On-campus libraries across North and South campuses with research databases, digital resources, and reading areas.' },
      { title: 'Hostels', desc: 'Separate residential hostels for boys and girls within the scenic Kamand campus with all essential amenities.' },
      { title: 'Sports', desc: 'Swimming pool, badminton courts, and outdoor sports fields catering to diverse athletic interests.' },
      { title: 'Medical', desc: 'On-campus medical unit providing primary and specialized healthcare to students and staff round the clock.' },
      { title: 'Research Labs', desc: 'Nine research centres including Quantum Science, Climate Change, and AI centres with state-of-the-art infrastructure.' },
      { title: 'Auditorium', desc: 'Fully equipped auditorium for academic seminars, cultural events, and national-level conferences.' },
    ],
  },
};

const PartnerModal = ({ partnerKey, onClose, onApplyNow }) => {
  const data = PARTNERS[partnerKey];

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    const handleKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', handleKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', handleKey);
    };
  }, [onClose]);

  if (!data) return null;

  const { name, hero, highlightsTitle, highlights, about, courses, placements, extraSections, facilities } = data;

  const handleApply = () => {
    onClose();
    onApplyNow(`Hi CampusXL, I would like to know more about the programs you offer with ${name}. Shall I get a call from your side?\nThanks.`);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-scroll">
          <div className="modal-close-row">
            <button className="modal-close" onClick={onClose} aria-label="Close">✕</button>
          </div>

          <div className="modal-hero">
            <img src={hero.image} alt={hero.alt} className="modal-hero-img" />
            <div className="modal-hero-overlay">
              <div>
                <h2 className="modal-title">{hero.title}</h2>
                <h4 className="modal-location">{hero.location}</h4>
                <div className="modal-tags">
                  {hero.tags.map((tag) => (
                    <span className="modal-tag" key={tag}>{tag}</span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="modal-body">

            <section className="modal-section">
              <p className="modal-section-title">About</p>
              {about.map((para, i) => <p key={i}>{para}</p>)}
            </section>

            <section className="modal-section">
              <p className="modal-section-title">{highlightsTitle}</p>
              <div className="modal-highlights-grid">
                {highlights.map(({ label, value, isLink }) => (
                  <div className="modal-highlight-card" key={label}>
                    <div className="modal-highlight-label">{label}</div>
                    <div className="modal-highlight-value">
                      {isLink
                        ? <a href={value} target="_blank" rel="noreferrer">{value}</a>
                        : value}
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="modal-section">
              <p className="modal-section-title">Courses & Eligibility</p>
              <div className="modal-table-wrap">
                <table className="modal-table">
                  <thead>
                    <tr>
                      <th>Program</th>
                      <th>Course</th>
                      <th>Duration</th>
                      <th>Eligibility</th>
                    </tr>
                  </thead>
                  <tbody>
                    {courses.map(({ program, course, duration, eligibility, badge }, idx) => (
                      <tr key={idx}>
                        <td className="modal-table-label">{program}</td>
                        <td>
                          {course}
                          {badge && <strong className="modal-course-badge"> · {badge}</strong>}
                        </td>
                        <td>{duration}</td>
                        <td>{eligibility}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>

            <section className="modal-section">
              <p className="modal-section-title">Placements</p>
              {placements.map((para, i) => <p key={i}>{para}</p>)}
            </section>

            {extraSections.map(({ title, paragraphs }) => (
              <section className="modal-section" key={title}>
                <p className="modal-section-title">{title}</p>
                {paragraphs.map((para, i) => <p key={i}>{para}</p>)}
              </section>
            ))}

            <section className="modal-section">
              <p className="modal-section-title">Facilities</p>
              <div className="modal-facilities-grid">
                {facilities.map(({ title, desc }) => (
                  <div className="modal-facility-card" key={title}>
                    <div className="modal-facility-title">{title}</div>
                    <p className="modal-facility-desc">{desc}</p>
                  </div>
                ))}
              </div>
            </section>

          </div>
        </div>{/* end modal-scroll */}
        <button className="modal-apply-btn" onClick={handleApply}>
          Apply Now
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default PartnerModal;
